/**
 * 智能会议室：教职工列表短时缓存，避免同一学校多组件重复请求
 */
import { getTeacherMasterList, getTeachingTeachersByDepartments } from '../api/meetingRoomApi';
import { normalizeDeptId } from './deptCascaderProps';

const cache = new Map();
const ttlMs = 5 * 60 * 1000;

/**
 * 按学校/部门拉取教职工（全量，与报修审批流一致）
 * @param {number|string} departmentId
 */
export function fetchTeachersByDepartment(departmentId) {
  const key = `school:${departmentId}`;
  const hit = cache.get(key);
  if (hit && Date.now() < hit.expireAt) {
    return Promise.resolve(hit.data.slice());
  }
  return getTeacherMasterList({ departmentId }).then(res => {
    if (!res.data.success) return [];
    const rows = res.data.response || [];
    cache.set(key, { data: rows, expireAt: Date.now() + ttlMs });
    return rows.slice();
  });
}

/**
 * 按部门获取可约教职工：该部门及全部下级部门的任教教师
 * @param {number|string} departmentId
 * @param {number|string} campusId 保留兼容，不参与请求
 */
export function fetchTeachingTeachersByDeptId(departmentId, campusId = 0) {
  const id = normalizeDeptId(departmentId);
  if (!id) return Promise.resolve([]);
  const key = `teach:v3:${id}`;
  const hit = cache.get(key);
  if (hit && Date.now() < hit.expireAt) {
    return Promise.resolve(hit.data.slice());
  }
  return getTeachingTeachersByDepartments({ departmentId: id }).then(res => {
    if (!res.data || !res.data.success) return [];
    const rows = (res.data.response || []).map(item => ({
      Id: item.Id,
      TeacherName: item.TeacherName,
      DepartmentName: item.DepartmentName || ''
    }));
    cache.set(key, { data: rows, expireAt: Date.now() + ttlMs });
    return rows.slice();
  });
}

export function clearMeetingRoomTeacherCache() {
  cache.clear();
}
